function NXAnalytics({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4291_1256)">
        <path
          d="M2.03711 11.2445L20.93 2.65233"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.3978 1.32152L20.93 2.65223L19.6157 6.18437"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.7678 22.6787H17.6607V11.1787C17.6607 10.9608 17.7473 10.7519 17.9012 10.5978C18.0553 10.4438 18.2643 10.3572 18.4821 10.3572H20.9464C21.1643 10.3572 21.3732 10.4438 21.5273 10.5978C21.6813 10.7519 21.7678 10.9608 21.7678 11.1787V22.6787Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5536 22.6787H9.44641V13.6429C9.44641 13.4251 9.53296 13.2161 9.68701 13.0621C9.84104 12.9081 10.05 12.8215 10.2678 12.8215H12.7321C12.95 12.8215 13.1589 12.9081 13.313 13.0621C13.467 13.2161 13.5536 13.4251 13.5536 13.6429V22.6787Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33926 22.6787H1.23212V16.1072C1.23212 15.8894 1.31866 15.6804 1.47271 15.5264C1.62676 15.3724 1.83569 15.2858 2.05355 15.2858H4.51783C4.73569 15.2858 4.94463 15.3724 5.09866 15.5264C5.25271 15.6804 5.33926 15.8894 5.33926 16.1072V22.6787Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4291_1256">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500092)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXAnalytics;
